// If you don't want to use TypeScript you can delete this file!
import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useColorModeValue as mode,
} from "@chakra-ui/react"
import { StaticImage } from "gatsby-plugin-image"
import { Layout, Seo } from "../components/global"
type DataProps = {
  site: {
    buildTime: string
  }
}

const UsingTypescript: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Layout>
    <Seo title="Quick Schedule Picker" />
    <Box
      as="section"
      bg={mode("gray.50", "gray.800")}
      pt="24"
      pb="12"
      overflow="hidden"
    >
      <Box
        maxW={{ base: "xl", md: "7xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
      >
        <Flex
          align="flex-start"
          direction={{ base: "column", lg: "row" }}
          justify="space-between"
          mb="20"
        >
          <Box flex="1" maxW={{ lg: "xl" }} pt="6">
            <Heading as="h1" size="xl" mt="8" fontWeight="extrabold">
              Quick Schedule Picker
            </Heading>
            <Text color={mode("gray.600", "gray.400")} mt="5" fontSize="xl">
              カレンダーを見ながら、空いてる日程候補をリスト化するChrome拡張です。
            </Text>
            <Text color={mode("gray.600", "gray.400")} mt="5" fontSize="xl">
              クリックするだけの簡単操作でよくある曜日と日にち間違いも防げます！
            </Text>
            <a
              href="https://chrome.google.com/webstore/detail/quick-schedule-picker/ojbdajgoakcjhbjmipnfcncenjldhcgk"
              target="_blank"
              rel="noopener"
            >
              <Button
                mt="8"
                minW="14rem"
                colorScheme="blue"
                size="lg"
                height="14"
                px="8"
                fontSize="md"
                fontWeight="bold"
              >
                Chrome ウェブストアへ
              </Button>
            </a>
          </Box>
          <Box boxSize={{ base: "20", lg: "8" }} />
          <StaticImage
            src="../images/home/useImage.jpg"
            width={800}
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="A Gatsby astronaut"
            style={{ width: "40vw" }}
          />
        </Flex>
      </Box>
    </Box>
  </Layout>
)

export default UsingTypescript

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
